<template>
  <v-container
    fill-height
    fluid
    class="d-flex justify-center align-center full-screen">
    <v-progress-circular
      color="#358ED7"
      indeterminate
      :size="200"
      :width="8" />
  </v-container>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style scoped>
.full-screen {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
